export function formatDate(value, format, mode) {
  if (!value) {
    return '';
  }
  if (Array.isArray(format)) {
    format = format[0];
  }
  if (typeof format === 'function') {
    var result = format(value);
    if (typeof result === 'string') {
      return result;
    } else {
      throw new Error('The function of format does not return a string');
    }
  }

  if (mode) {
    if (Array.isArray(mode) ? mode.includes('halfyear') : mode === 'halfyear') {
      return halfYearFormat(value, format);
    }
  }

  return value.format(format);
}

/**
 * 半年格式化函数
 * @param {object} value moment时间实例
 * @param {string} valueFormat 格式化字符串模板
 * @returns 格式化后字符串
 */
export function halfYearFormat(value, valueFormat) {
  var val = Math.ceil(value.format('Q') / 2);
  var p = valueFormat.replace(/(\[.+?\].*?)?F(.*?)/g, '$1' + val + '$2');
  return value.format(p);
}

/**
 * 半年字符串格式化为moment
 * @param {function} moment Moment对象
 * @param {string} value 绑定值
 * @param {string} valueFormat 绑定值格式
 * @returns
 */
export function halfYearFormatToMoment(moment, value, valueFormat) {
  // 替换半年`F`格式为季度`Q`
  var f = valueFormat.replace(/(\[.+?\].*?)?F(.*?)/g, '$1Q$2');

  var valueSplit = value.split('');
  // 默认最后一位是哪个半年
  var halfyear = valueSplit.at(-1);
  // 默认转换为第2和第4季度
  var quarter = halfyear * 2;
  // 把季度值格式化为moment
  return moment('' + valueSplit.slice(0, -1).join('') + quarter, f);
}